module.exports = __webpack_public_path__ + "assets/img/cee8-bm.svg";